/* eslint-disable react/jsx-newline */
import "./MyAccount.scss";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Route, Routes } from "react-router";
import PageHeader from "../../components/PageHeader";
import { useMemo } from "react";

import { Default } from "../../components/Devices";
import MyAccountAccount from "./MyAccount/MyAccountManage";
import MyAccountCommunications from "./tabs/MyAccountCommunications";
import MyAccountDashboard from "./tabs/MyAccountDashboard";
import MyAccountFacilitatorProfile from "./tabs/MyAccountFacilitatorProfile";
import MyAccountMyCourses from "./tabs/MyAccountMyCourses";
import MyAccountNavigation from "./MyAccountNavigation";
import MyAccountPastCourses from "./tabs/MyAccountPastCourses";
import MyAccountProfile from "./tabs/MyAccountProfile";
import MyCourseRoutes from "./MyCourse/MyCourseRoutes";
import RegisterSuccess from "../login/RegisterSuccess";
import RequireAuth from "../../components/RequireAuth";

import { hasRole } from "../../services/wp.user.service";
import { useAuth } from "../../services/wp.auth.service";
import { userCanRegister } from "../../helpers/authHelpers";

const MyAccountLayout = () => {
	const { user } = useAuth();
	const canRegister = useMemo(() => userCanRegister(user), [user]);
	return (
		<>
			<PageHeader fluid title="My Account" />
			<Container className="py-4 my-account">
				<Card>
					<Row className="gx-0">
						<Default>
							<Col className="ps-0 pt-4 pb-4 pe-5 border-end" md="auto" sm={12}>
								<MyAccountNavigation />
							</Col>
						</Default>
						<Col className="p-4" md sm={12}>
							<Routes>
								{canRegister ? (
									<>
										<Route element={<MyCourseRoutes />} path="classes/:courseId/*" />
										<Route element={<MyAccountMyCourses />} path="classes" />
										<Route element={<MyAccountPastCourses />} path="past-classes" />
									</>
								) : null}
								{hasRole("attendee") ? <Route element={<MyAccountProfile />} path="profile" /> : null}
								{hasRole("facilitator") ? (
									<Route
										element={<RequireAuth requireRole="facilitator"><MyAccountFacilitatorProfile /></RequireAuth>}
										path="profile"
									/>) : null}
								<Route element={<MyAccountAccount />} path="manage" />
								<Route element={<MyAccountCommunications />} path="communications" />
								<Route element={<RegisterSuccess />} path="register-success" />
								<Route element={<MyAccountDashboard />} path="*" />
							</Routes>
						</Col>
					</Row>
				</Card>
			</Container>
		</>
	);
};

export default MyAccountLayout;
